'use client';

import { CatalogueSection } from 'components/powerplugs/CatalogueSection';
import { Powerplugs_HeroSection } from 'components/powerplugs/HeroSection';
// import { StackCardComponent } from 'components/power/StackCardComponent';
import { TitleVideoAutoplaySection } from 'components/powerplugs/TitleVideoAutoplaySection';
import { ToggleAnimationSection } from 'components/powerplugs/ToggleAnimationSection';
import { StackCardComponent } from 'components/powerplugs/StackCardComponent';
import { TextOpacityOnScrollSection } from 'components/powerplugs/TextOpacityOnScrollSection';
import { PointsExplainerSection } from 'components/powerplugs/PointsExplainerSection';
import { getPowerplugsPageFaqData } from 'content/powerplugsFaqData';
import { FAQSection } from 'components/shared/FAQSection';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import { useTranslations } from 'next-intl';

const Powerplugs = () => {
  const t = useTranslations('powerplugs');
  return (
    <main>
      <Powerplugs_HeroSection />
      <TextOpacityOnScrollSection />
      <PointsExplainerSection />
      <CatalogueSection />
      <TitleVideoAutoplaySection
        title={
          <>
            {t('powerplugsPage.sectionTitles.customize')}
            {/* Customise your
            <br /> Ultrahuman experience */}
          </>
        }
        src={getCompressedAssetUrl(
          '/web_v2/videos/powerplugs-experience-desktop.mp4',
        )}
        srcResponsive={getCompressedAssetUrl(
          '/web_v2/videos/powerplugs-experience-responsive.mp4',
        )}
      />
      <ToggleAnimationSection />
      <StackCardComponent />
      <FAQSection faqData={getPowerplugsPageFaqData(t)} />
    </main>
  );
};

export default Powerplugs;
